var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"vVq_Wa_1Myn4x1Z88_gMW"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prod-care-worker-frontend@usen-working"]={id:"vVq_Wa_1Myn4x1Z88_gMW"};
      